import { createAction } from '@reduxjs/toolkit';

import type { FieldType } from '@lt/widget/components/Cigarette/types';
import * as VIEW from '../constants/view';
import { CHANGE_SELECTED_FLIGHT_CLASS } from '../../CheckoutRoutes/PackageCheckout/store/flights/constants';

export const toggleMapAction = () => ({
  type: VIEW.TOGGLE_MAP,
});

export const changeFlightClassAction = (payload) => ({
  type: CHANGE_SELECTED_FLIGHT_CLASS,
  payload,
});

export const goToHotelSectionAction = () => ({
  type: VIEW.GO_TO_HOTEL,
});

export const goToPathAction = createAction<string | undefined>(VIEW.GO_TO_PATH);

export const goToTouristsAction = createAction<number | undefined>(
  VIEW.GO_TO_TOURISTS,
);

export const goToTouristsHotelCheckoutAction = createAction<number>(
  VIEW.GO_TO_TOURISTS_HOTEL_CHECKOUT,
);

export const goToPayAction = () => ({
  type: VIEW.GO_TO_PAY,
});

export const goToClientAction = () => ({
  type: VIEW.GO_TO_CLIENT,
});

export const goToClientDataAction = createAction(VIEW.GO_TO_CLIENT_DATA);

export const goToFlightSectionAction = () => ({
  type: VIEW.GO_TO_FLIGHT,
});

export const scrollToTouristsAction = () => ({
  type: VIEW.SCROLL_TO_TOURISTS,
});

export const scrollToPaymentAction = createAction(VIEW.SCROLL_TO_PAYMENT_BLOCK);

export const scrollToLogInAction = () => ({
  type: VIEW.SCROLL_TO_LOG_IN,
});

export const scrollToTopAction = () => ({
  type: VIEW.SCROLL_TO_TOP,
});

export const scrollToBooking = () => ({
  type: VIEW.SCROLL_TO_BOOKING,
});

export const routeTransitionStartAction = () => ({
  type: VIEW.ROUTE_TRANSITION_START,
});

export const routeTransitionEndAction = () => ({
  type: VIEW.ROUTE_TRANSITION_END,
});

export const expandTouristFormAction = (payload) => ({
  type: VIEW.EXPAND_TOURIST_FORM,
  payload,
});

export const shrinkTouristFormsAction = createAction('SHRINK_TOURIST_FORMS');

export const setTopbarIndexAction = (payload) => ({
  type: VIEW.SET_TOPBAR_INDEX,
  payload,
});
export const toggleTopbarAction = (payload) => ({
  type: VIEW.TOGGLE_TOPBAR,
  payload,
});

export const setScrollPositionAction = (payload) => ({
  type: VIEW.SCROLL_POSITION,
  payload,
});

export const resetScrollPositionAction = () => ({
  type: VIEW.RESET_SCROLL_POSITION,
});

export const toggleFiltersPanelAction = () => ({
  type: VIEW.TOGGLE_FILTERS_PANEL,
});

export const setFlightsProgressBarIsSticky = createAction<boolean>(
  VIEW.SET_FLIGHTS_PROGRESSBAR_IS_STICKY,
);

export const setShowSummaryAction = createAction<boolean>(
  VIEW.SET_SHOW_SUMMARY,
);

export const setInitialOpenedField = createAction<FieldType | undefined>(
  VIEW.SET_INITIAL_OPENED_FIELD,
);

export const onClientClickAction = createAction('ON_CLIENT_CLICK');
